import React,{ useEffect } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate,useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const Update = () => {

    const { id } = useParams();
    const {readData} = useEntityCrud('User/GetUser?UserId=' + id);
    const {readData: getBusiness} = useEntityCrud('Business/GetAllBusiness');
    const {addData: updateData} = useEntityCrud('User/UpdateUser');
    const navigate = useNavigate();

    const initialValues = {
        name: '',
        lastName: '',
        nationalCode: '',
        phone: '',
        password: '',
        businessId: [],
        roleId: ''
    };

    useEffect(() => {
        let businesses = [];
        getBusiness().then((res) => {
            if(res.data.status){
                res.data.result.map(item => {
                    if(item.isActive)
                        businesses.push({
                            label: item.title,
                            value: item.id
                        });
                })
                readData().then(({data}) => {
                    if(data.status){
                        let businessId = [];
                        if(data.result.businessId)
                            businessId = businesses.filter(item => data.result.businessId.includes(item.value));
                        let values = {
                            ...data.result,
                            name: data.result.firstName,
                            phone: data.result.mobile.slice(0,4) + '-' + data.result.mobile.slice(4,11),
                            businessId,
                            guildId: typeof data.result.guildId == 'number' ? [data.result.guildId] : data.result.guildId
                        };
                        formik.setValues(values);
                    }
                });
            }
        });
    },[]);
    
    const validationSchema = Yup.object({
        name: Yup.string()
        .required(),
        lastName: Yup.string()
        .required(),
        nationalCode: Yup.string()
        .test('nationalCode','کد ملی وارد شده معتبر نمی باشد',code => {
            if(!code || code.length != 10)
                return false;
            let L = code.length;
            if(L < 8 || parseInt(code,10) == 0) return false;
            code = ('0000' + code).substr(L + 4 - 10);
            if(parseInt(code.substr(3,6),10)==0) return false;
            let c = parseInt(code.substr(9,1),10);
            let s = 0;
            for(let i = 0;i < 9;i++)
                s += parseInt(code.substr(i,1),10) * (10 - i);
            s = s % 11;
            return (s < 2 && c == s) || (s >= 2 && c == (11 - s));
        })
        .required(),
        phone: Yup.string()
        .test('phone','شماره همراه وارد شده معتبر نمی باشد',value => {
            return value && /^\d+$/.test(value.toString().replace('-','')) && value.startsWith('09') && value.length == 12;
        }),
        roleId: Yup.number()
        .required()
    });
    
    const onSubmit = (values) => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        let businessId = [];
        if(values.businessId.length)
            values.businessId.map(item => businessId.push(item.value));
        const postedData = {
            id,
            firstName: values.name,
            lastName: values.lastName,
            nationalCode: values.nationalCode,
            mobile: values.phone.replace('-',''),
            token: '',
            username: values.nationalCode,
            password: values.password != '' ? values.password : null,
            roleId: values.roleId,
            businessId: businessId
       };
       if(values.guildId){
            if(typeof values.guildId == 'number')
                postedData.guildId = [values.guildId]
            else{
                const guilds = []
                values.guildId.map(guild => guilds.push(typeof guild == 'number' ? guild : guild.value))
                postedData.guildId = guilds
            }
        }
        updateData(postedData).then(({data}) => {
            if(data.status){
                toast.success('به روزرسانی کاربر با موفقیت انجام شد');
                return navigate('/users');
            }else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/users',{replace: true});
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ویرایش کاربر</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} id={id} />
            </div>
        </div>
    );
}

export default Update;